import * as React from "react";
import { useSelector } from "react-redux";
import CountryJSON from "../countries.json";
import { currencyFormat } from "../helper";

const CountryContext = React.createContext({});

const CountryProvider = ({ children }) => {
  const [currency, setCurrency] = React.useState({});
  const shopDetails = useSelector((state) => state.shopDetails);
  React.useEffect(() => {
    const value =
      CountryJSON[shopDetails.country.dialCode] || CountryJSON["+91"];
    setCurrency(value);
  }, [shopDetails]);
  const memorizeThecurrency = React.useMemo(() => currency, [currency]);
  return (
    <CountryContext.Provider value={memorizeThecurrency}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCurrency = () => {
  const country = React.useContext(CountryContext);

  const currencyFormatter = (price, icon = true) => {
    if (icon) {
      return country.CurrencySymbol + " " + currencyFormat(price);
    } else {
      return currencyFormat(price);
    }
  };
  if (!country) {
    throw new Error(`useCurrency must be used within a CountryProvider`);
  }
  return currencyFormatter;
};

export const useCountry = () => {
  const country = React.useContext(CountryContext);

  if (!country) {
    throw new Error(`useCountry must be used within a CountryProvider`);
  }

  return country;
};

export default CountryProvider;
